import { render, staticRenderFns } from "./MainFooterBlock.vue?vue&type=template&id=944c2f7c&scoped=true"
import script from "./MainFooterBlock.vue?vue&type=script&lang=ts"
export * from "./MainFooterBlock.vue?vue&type=script&lang=ts"
import style0 from "./MainFooterBlock.vue?vue&type=style&index=0&id=944c2f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944c2f7c",
  null
  
)

export default component.exports